import { formatMoney } from '@travelata-libs/utils';
import { PREPAYMENT_TEXTS } from '../config/texts';
import type { PrepaymentSummary } from '../model/types';

const WHITESPACE_RE = /\s/g;
const NBSP = '\u00A0';

/** Подпись предоплаты в карточке выдачи: «от 37 543 ₽ по предоплате 50%». */
export function formatPrepaymentLabel(summary: PrepaymentSummary): string {
  // formatMoney разделяет разряды обычным пробелом — меняем на NBSP, чтобы сумма не рвалась переносом.
  const amount = formatMoney(summary.amount).replaceAll(WHITESPACE_RE, NBSP);

  return `${PREPAYMENT_TEXTS.amountFrom} ${amount} ${PREPAYMENT_TEXTS.partPrefix} ${summary.percent}%`;
}
